export default __webpack_public_path__ + "static/media/placeholder_dummy2016-friseur01-de.21f93c4f.png";